import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: [],
	loading: false,
	error: null,
	// CRUD in-flight state
	saving: false,
	deleting: false,
	// External IR TimePeriods (for duplicate detection + link picker)
	externalTimePeriods: [],
	externalLoading: false,
	// Dismissed duplicate pairs: ['accessWindowID:externalAddress', ...]
	dismissedDuplicates: [],
	// Link integration in-flight
	linking: false
};

const accessWindowsSlice = createSlice({
	name: 'accessWindows',
	initialState,
	reducers: {
		// ── Load all ──
		loadAccessWindows: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadAccessWindowsSuccess: (state, action) => {
			state.data = action.payload;
			state.loading = false;
		},
		loadAccessWindowsError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},

		// ── Create ──
		createAccessWindow: (state) => {
			state.saving = true;
			state.error = null;
		},
		createAccessWindowSuccess: (state) => {
			state.saving = false;
		},
		createAccessWindowError: (state, action) => {
			state.saving = false;
			state.error = action.payload;
		},

		// ── Update ──
		updateAccessWindow: (state) => {
			state.saving = true;
			state.error = null;
		},
		updateAccessWindowSuccess: (state) => {
			state.saving = false;
		},
		updateAccessWindowError: (state, action) => {
			state.saving = false;
			state.error = action.payload;
		},

		// ── Delete ──
		deleteAccessWindow: (state) => {
			state.deleting = true;
			state.error = null;
		},
		deleteAccessWindowSuccess: (state) => {
			state.deleting = false;
		},
		deleteAccessWindowError: (state, action) => {
			state.deleting = false;
			state.error = action.payload;
		},

		// ── External IR TimePeriods ──
		loadExternalTimePeriods: (state) => {
			state.externalLoading = true;
		},
		loadExternalTimePeriodsSuccess: (state, action) => {
			state.externalTimePeriods = action.payload;
			state.externalLoading = false;
		},
		loadExternalTimePeriodsError: (state) => {
			state.externalLoading = false;
		},

		// ── Link to IR ──
		linkToIR: (state) => {
			state.linking = true;
		},
		linkToIRSuccess: (state) => {
			state.linking = false;
		},
		linkToIRError: (state) => {
			state.linking = false;
		},

		// ── Dismiss duplicate ──
		dismissDuplicate: (state, action) => {
			// payload = 'accessWindowID:externalAddress'
			if (!state.dismissedDuplicates.includes(action.payload)) {
				state.dismissedDuplicates.push(action.payload);
			}
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => initialState);
		builder.addCase('auth/switchProfileSuccess', () => initialState);
	}
});

export const accessWindowsActions = accessWindowsSlice.actions;
export default accessWindowsSlice.reducer;
